<template>
  <div class="error-page">
    <h1 class="title">Ocorreu um erro!</h1>

    <div class="description">
      <slot name="description">
        <p>
          Infelizmente não foi possível carregar as informações solicitadas.<br>
          Por favor tente novamente, ou contate nossa equipe.
        </p>
      </slot>
    </div>

    <div class="actions" v-if="$scopedSlots.actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',

  props: {
    title: {
      required: false,
      type: String,
      default: 'Ocorreu um erro!',
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  @apply p-20;
  @apply flex;
  @apply flex-col;

  > .title {
    @apply text-secondary-800;
    @apply font-bold;
    @apply text-center;
    @apply w-full;
    font-size: 1.875rem;
  }

  > .description {
    @apply text-sm;
    @apply text-secondary-900;
    @apply mt-2;
    @apply w-2/3;
    @apply self-center;
    @apply text-center;
  }

  > .actions {
    @apply self-center;
    @apply text-center;
    @apply gap-2;
    @apply flex;
    @apply mt-4;
  }
}
</style>
